var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"media-card media-card-simple mt-1 mb-2",class:{
    'media-card-dy': _vm.client_name == 'DY',
    'media-card-mid': _vm.client_name == 'MID',
  },attrs:{"title":_vm.title,"sub-title":_vm.duration,"img-src":_vm.img_src,"img-alt":"Image","img-top":"","tag":"article"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0164d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media_components/SimpleMediaCard.vue
// module id = null
// module chunks = 